// SectorDetail.jsx
import React, { useState } from "react";
import { useParams, Link } from "react-router-dom";

import aviationImg from "../Assessts/homeImages/rafele1_hover.png";
import defenceImg from "../Assessts/homeImages/s400-hover.png";
import warshipImg from "../Assessts/homeImages/warship-hover.png";
import droneImg from "../Assessts/homeImages/UAV-hover.png";
import aerospaceImg from "../Assessts/homeImages/aerospace-hover.png";
import railwayImg from "../Assessts/homeImages/Railway-hover.png";

const sectorDetails = {
  airforce: {
    title: "AIRFORCE",
    img: aviationImg,
    points: [
      <>🔹 Advanced avionics solutions with <strong>gyroscopes and accelerometers</strong> improve navigation and mission control accuracy.</>,
      <>🔹 <strong>Pressure and altitude sensors</strong> ensure precise monitoring in fighter aircraft systems under extreme conditions.</>,
      <>🔹 Rugged cable harnesses and <strong>temperature sensors</strong> withstand harsh aerospace environments.</>,
      <>🔹 DAQ systems with integrated <strong>inertial measurement sensors (IMUs)</strong> enhance aircraft performance testing and evaluation.</>
    ]
  },
  miltary: {
    title: "MILITARY",
    img: defenceImg,
    points: [
      <>🔹 RF & Microwave systems with <strong>radar sensors</strong> strengthen communication and surveillance networks.</>,
      <>🔹 Embedded computing solutions integrate with <strong>infrared and thermal sensors</strong> to support real-time battlefield operations.</>,
      <>🔹 <strong>Laser rangefinders and gyroscopic sensors</strong> improve fire-control accuracy in armored vehicles and artillery.</>,
      <>🔹 Rugged assemblies with <strong>vibration and shock sensors</strong> ensure mission reliability in harsh defence conditions.</>
    ]
  },
  navy: {
    title: "NAVY",
    img: warshipImg,
    points: [
      <>🔹 <strong>Sonar sensors</strong> monitor navigation, object detection, and propulsion systems in naval fleets.</>,
      <>🔹 RF technologies combined with <strong>radar sensors</strong> ensure secure ship-to-ship and ship-to-shore communication.</>,
      <>🔹 <strong>Pressure and gyroscopic sensors</strong> provide accuracy in submarine depth and direction control.</>,
      <>🔹 Rugged assemblies with <strong>humidity and vibration sensors</strong> ensure durability in harsh marine environments.</>
    ]
  },
  drones: {
    title: "DRONES/UAV",
    img: droneImg,
    points: [
      <>🔹 <strong>GPS and IMU (gyroscope + accelerometer) sensors</strong> support stable altitude and navigation control.</>,
      <>🔹 Embedded computing integrates with <strong>LiDAR and vision sensors</strong> to power autonomous flight and target tracking.</>,
      <>🔹 <strong>Altitude and airspeed sensors</strong> feed data to DAQ systems for performance monitoring during UAV missions.</>,
      <>🔹 Rugged electronics with <strong>temperature and vibration sensors</strong> ensure reliability in long-duration operations.</>
    ]
  },
  aerospace: {
    title: "AEROSPACE",
    img: aerospaceImg,
    points: [
      <>🔹 <strong>Inertial sensors (gyroscopes and accelerometers)</strong> in avionics systems improve spacecraft navigation and safety.</>,
      <>🔹 <strong>Star trackers and sun sensors</strong> stabilize communication satellites and payload systems in orbit.</>,
      <>🔹 RF & Microwave technologies work alongside <strong>antenna positioning sensors</strong> to support space communication links.</>,
      <>🔹 Ruggedized components with <strong>temperature and pressure sensors</strong> survive extreme launch, vacuum, and re-entry conditions.</>
    ]
  },
  railway: {
    title: "RAILWAY",
    img: railwayImg,
    points: [
      <>🔹 <strong>Vibration and strain sensors</strong> monitor track conditions for predictive maintenance and safety.</>,
      <>🔹 <strong>Speed and rotary encoders</strong> ensure precision control in high-speed locomotives.</>,
      <>🔹 <strong>Temperature and current sensors</strong> within DAQ systems enhance rail network performance monitoring.</>,
      <>🔹 <strong>Battery health and voltage sensors</strong> in power backup solutions guarantee uninterrupted signalling systems.</>
    ]
  }
};

export default function SectorDetail() {
  const { id } = useParams();
  const sector = sectorDetails[id];
  const [hovered, setHovered] = useState(false);

  if (!sector) {
    return (
      <div style={{ textAlign: "center", marginTop: "50px" }}>
        <h2>Sector Not Found</h2>
        <Link to="/" style={{ color: "#0077ff", textDecoration: "none" }}>
          Go Back
        </Link>
      </div>
    );
  }

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        gap: "40px",
        padding: "50px",
        alignItems: "flex-start",
        maxWidth: "1100px",
        margin: "50px auto",
      }}
    >
      {/* Image with hover effect */}
      <img
        src={sector.img}
        alt={sector.title}
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
        style={{
          maxWidth: "400px",
          borderRadius: "12px",
          boxShadow: hovered
            ? "0 8px 24px rgba(27, 6, 100, 0.6)"
            : "0 4px 12px rgba(0,0,0,0.2)",
          transform: hovered ? "translateY(-6px)" : "translateY(0)",
          transition: "all 0.3s ease-in-out",
          cursor: "pointer",
        }}
      />

      {/* Info */}
      <div style={{ flex: 1 }}>
        <h1 style={{ marginBottom: "20px", fontSize: "28px", color: "#074f86ff" }}>
          {sector.title}
        </h1>
        <div style={{ marginBottom: "30px", fontSize: "18px", lineHeight: "1.8" }}>
          {sector.points.map((point, index) => (
            <p key={index} style={{ marginBottom: "12px" }}>
              {point}
            </p>
          ))}
        </div>

        <Link
          to="/"
          style={{
            padding: "10px 20px",
            background: "#0077ff",
            color: "#fff",
            textDecoration: "none",
            borderRadius: "6px",
            fontWeight: "500",
            transition: "background 0.3s ease",
          }}
          onMouseOver={(e) => (e.target.style.background = "#0056b3")}
          onMouseOut={(e) => (e.target.style.background = "#0077ff")}
        >
          ← Back to Sectors
        </Link>
      </div>
    </div>
  );
}
